function BaseUrl(useDevRemote?: boolean): string {
  const location = window.location.origin;
  if (useDevRemote && location.includes("//localhost:"))
    return process.env.REACT_APP_API_URL || location;
  return location;
}

export { BaseUrl };
